import "./styles.css";
import React, { useContext } from "react";
import { Layout, Space, Typography, Menu, Modal, Popover, Avatar, Badge, Row, Col, message } from "antd";
import {
  HomeOutlined,
  UserOutlined,
  LogoutOutlined,
  BellOutlined,
  FacebookFilled,
  InstagramFilled,
  WhatsAppOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { configModal } from "../modalConfig/config";
import { useState } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { ContentLayout } from "../contentLayout/contentLayout";
import { IMAGES } from "../../constants/images";
import http from "../../services/http";

const { Text, Link } = Typography;
const { Footer, Content } = Layout;

const colStyle = {
  padding: 10,
};

const linkStyle = {
  fontSize: 14,
  color: "#fff",
};

const socialStyle = {
  fontSize: 26,
  color: "#fff",
};

export const AuthLayout = ({ children }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [modal, contextHolder] = Modal.useModal();
  const { pendencias, encerrarSessao, session } = useContext(AuthContext);

  const logout = async () => {
    const api = await http("get", "v1/autenticacao/logout", []);
    if (api.statusCode === 200 || api.statusCode === 401) {
      await encerrarSessao();
      navigate("/login");
      message.success("Logout Realizado com sucesso!");
    } else {
      message.success(api.response.message);
    }
  };

  // ITENS MENU
  const items = [
    {
      label: "Página Inicial",
      key: "home",
      icon: <HomeOutlined style={{ fontSize: 16 }} />,
      onClick: () => {
        navigate("/");
        setOpen(false);
      },
    },
    {
      label: "Perfil",
      key: "perfil",
      icon: <UserOutlined style={{ fontSize: 16 }} />,
      onClick: () => {
        navigate("/perfil");
        setOpen(false);
      },
    },
    {
      label: "Vídeos Explicativos",
      key: "ajuda",
      icon: <VideoCameraOutlined style={{ fontSize: 16 }} />,
      onClick: () => {
        navigate("/video");
        setOpen(false);
      },
    },
    {
      label: "Sair",
      key: "logout",
      icon: <LogoutOutlined style={{ fontSize: 16 }} />,
      onClick: () => {
        modal.confirm({
          ...configModal,
          title: "Deseja sair do sistema?",
          onOk() {
            logout();
          },
        });
      },
    },
  ];

  const handleHoverChange = () => {
    setOpen(false);
  };

  const content = <Menu selectedKeys={[]} style={{ border: "none" }} items={items} />;

  // HEADER DROPDOWN PROFILE
  const HeaderPopover = () => {
    return (
      <Space size={20}>
        <Avatar size="large" shape="square" style={{ backgroundColor: "#87d068" }} icon={<UserOutlined />} />
        <Text ellipsis style={{ width: 120 }}>
          {session?.usuario?.nome?.split(" ")[0]}
        </Text>
      </Space>
    );
  };

  return (
    <ContentLayout>
      <Layout.Header className="page-header">
        <Space size={20} className="header-content">
          <div className="logo-container">
            <img
              style={{ maxHeight: 25, objectFit: "contain" }}
              width={"100%"}
              alt="copérdia"
              onClick={() => navigate("/")}
              src={IMAGES?.logoWhite}
            />
          </div>

          <Space size={20}>
            <Badge count={pendencias?.notificacoes}>
              <Avatar
                onClick={() => navigate("/notificacoes")}
                style={{ backgroundColor: "#f9ad5b" }}
                shape="square"
                className="pointer"
                icon={<BellOutlined />}
                size="large"
              />
            </Badge>
            <Popover
              open={open}
              onOpenChange={handleHoverChange}
              content={content}
              onClick={() => setOpen(!open)}
              title={HeaderPopover}
              trigger="click">
              <Avatar
                style={{ backgroundColor: "#87d068" }}
                className="pointer"
                shape="square"
                icon={<UserOutlined />}
                size="large"
              />
            </Popover>
          </Space>
        </Space>
      </Layout.Header>

      <Content className="content-page">{children}</Content>

      <RenderFooter />

      {contextHolder}
    </ContentLayout>
  );
};

const RenderFooter = () => {
  return (
    <Footer className="footer-content">
      <Row align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <Row>
            <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} style={colStyle}>
              <Space direction="vertical" size={4}>
                <img
                  src={"https://statics.coperdia.com.br/portal_colaborador/img/logo-coperdia-large.png"}
                  width={180}
                  style={{ objectFit: "contain", marginBottom: 10 }}
                />

                <Text strong style={linkStyle}>
                  COOPERATIVA DE PRODUÇÃO E CONSUMO CONCÓRDIA – Matriz
                </Text>
                <Text style={linkStyle}>Rua Dr. Maruri 1586 – Concórdia – SC</Text>
                <Text strong style={linkStyle}>
                  49 3441-4200
                </Text>
              </Space>
            </Col>

            <Col xs={0} sm={0} md={12} lg={12} xl={8} xxl={8} style={colStyle}>
              <Space direction="vertical" size={4}>
                <Text strong style={{ fontSize: 18, color: "#fff" }}>
                  Links Úteis
                </Text>

                <Link href="https://webmail.coperdia.com.br/" target="_blank" style={linkStyle}>
                  Webmail
                </Link>
                <Link href="http://www.coperdia.com.br/aplicativos/" target="_blank" style={linkStyle}>
                  Aplicativos Web
                </Link>
                <Link href="https://portal.coperdia.com.br/" target="_blank" style={linkStyle}>
                  Portal Copérdia
                </Link>
                <Link href="https://consentimentos.coperdia.com.br/" target="_blank" style={linkStyle}>
                  Consentimentos LGPD
                </Link>
              </Space>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} style={colStyle}>
              <Space direction="vertical" size={4}>
                <Space direction="vertical" size={4}>
                  <Text strong style={{ fontSize: 18, color: "#fff" }}>
                    Redes Sociais
                  </Text>
                  <Space size={10}>
                    <Link href="https://www.facebook.com/coperdia" target="_blank" style={socialStyle}>
                      <FacebookFilled />
                    </Link>
                    <Link href="https://www.instagram.com/coperdia.cooperativa/" target="_blank" style={socialStyle}>
                      <InstagramFilled />
                    </Link>
                    <Link href="https://wa.me/message/WKIFUWDNKN2FG1" target="_blank" style={socialStyle}>
                      <WhatsAppOutlined />
                    </Link>
                  </Space>
                </Space>

                <Text strong style={{ fontSize: 18, color: "#fff" }}>
                  Aplicativo
                </Text>
                <Space wrap size={15}>
                  <a
                    target="_blank"
                    href="https://apps.apple.com/br/app/cop%C3%A9rdia-colaborador/id6449134077?platform=iphone">
                    <img
                      src={"https://statics.coperdia.com.br/portal_colaborador/img/apple_store.png"}
                      width={140}
                      style={{ objectFit: "contain" }}
                    />
                  </a>
                  <a
                    target="_blank"
                    href="https://play.google.com/store/apps/details?id=br.com.coperdia.app_colaborador">
                    <img
                      src={"https://statics.coperdia.com.br/portal_colaborador/img/google_store.png"}
                      width={140}
                      style={{ objectFit: "contain" }}
                    />
                  </a>
                </Space>
              </Space>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} style={colStyle}></Col>
          </Row>
        </Col>
      </Row>
    </Footer>
  );
};
